import script from "./CreateUserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUserInfo.vue?vue&type=script&setup=true&lang=js"

import "./CreateUserInfo.vue?vue&type=style&index=0&id=2f2481bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2481bc"]])

export default __exports__